module.exports = __webpack_public_path__ + "static/media/Dashboard.543f4972.svg";